import SocialMediaIcons from "../components/SocialMediaIcons";
import useMediaQuery from "../hooks/useMediaQuery";
import { motion } from 'framer-motion';
import AnchorLink from "react-anchor-link-smooth-scroll";

const Home = ({ setSelectedPage }) => {
    const isAboveLarge = useMediaQuery("(min-width: 1060px)");
    return (
        <section
          id="home"
          className="md:flex md:justify-between md:items-center gap-16 md:h-full py-10"
          >
            <div className="basis-3/5 z-10 mt-16 md:mt-32 flex justify-center md:order-2">
                {isAboveLarge ? (
                    <div 
                    >
                    <img
                    alt="profile"
                    src="assets/profilePicture.webp"
                    />
                    </div>
                ): (
                    <img
                    alt="profile"
                    src="assets/profilePicture.webp"
                    />
                )}
            </div>
            <div className="z-30 basis-2/5 mt-12 md:mt-32">
                <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.5 }}
                variants={{
                    hidden: { opacity:0, x: -50 },
                    visible: { opacity: 1, x: 0 },
                }}
                >
                    <p className="text-6xl font-playfair x-10 text-center md:text-start">
                        Ivonne {""}
                        <span
                        className="xs:relative xs:text-deep-blue xs:font-semibold x-20 xs:before:content-brush
                        before:absolute before:-left-[25px] before:-top-[70px] before:z-[-1]"
                        >
                            Benites
                        </span>
                    </p>
                    <p className="mt-10 mb-7 text-sm text-center md:text-start">
                        Full Stack Developer experienced in JavaScript, Ruby, and PostgreSQL databases, with a strong background in Marketing, Hotel Management, and entrepreneurship.
                    </p>
                </motion.div>
                <motion.div
                  className="flex mt-5 justify-center md:justify-start"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.5 }}
                  transition={{ delay: 0.2, duration:0.5 }}
                  variants={{
                    hidden: { opacity: 0, x: -50 },
                    visible: { opacity:1, x:0 },
                  }}
                  >
                    <AnchorLink
                    className="bg-gradient-rainblue text-deep-blue rounded-sm py-3 px-7 
                    font-semibold hover:bg-blue hover:text-white transition duration-500"
                    onClick={() => setSelectedPage("contact")}
                    href="#contact"
                    >
                        Contact Me
                    </AnchorLink>
                    <AnchorLink
                     className="rounded-r-sm bg-gradient-rainblue py-0.5 pr-0.5"
                     onClick={() => setSelectedPage("contact")}
                     href="#contact"
                     >
                        <div className="bg-deep-blue hover:text-red transition duration-500 w-full h-full flex items-center justify-center px-10 font-playfair">
                            Let's talk.
                        </div>
                        </AnchorLink>   
                    </motion.div>
                    <motion.div
                        className="flex mt-5 justify-center md:justify-start"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.5 }}
                        transition={{ delay: 0.4, duration: 0.5 }}
                        variants={{
                            hidden: { opacity: 0, x: -50 },
                            visible: { opacity: 1, x:0 },
                        }}
                        >
                            <SocialMediaIcons />
                        </motion.div>
                        </div>
          </section>
    );
};

export default Home; 